// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__LF2ZZ","accordiontitle":"Accordion_accordiontitle__Bt1OA","accordioncontent":"Accordion_accordioncontent__xJV-6"};